module.exports = __webpack_public_path__ + "img/bubble-follow.27ccf14d.png";